import { render, staticRenderFns } from "./magicService.vue?vue&type=template&id=ef2b5cce&scoped=true&"
import script from "./magicService.ts?vue&type=script&lang=js&"
export * from "./magicService.ts?vue&type=script&lang=js&"
import style0 from "./magicService.less?vue&type=style&index=0&id=ef2b5cce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2b5cce",
  null
  
)

export default component.exports